import {Pipe, PipeTransform} from "@angular/core";

@Pipe({
    name: 'highlight'
})
export class KanHighlightPipe implements PipeTransform {
    transform(value: string = '', seatchText: string = ''): string {
        if (seatchText.trim()) {
            let matchs = [];
            seatchText.trim()
                .split(/\s+/)
                .forEach((s) => {
                    s = s.replace(/[aäàá]/g, '[aäàá]')
                        .replace(/[eëéè]/g, '[eëéè]')
                        .replace(/[iïíì]/g, '[iïíì]')
                        .replace(/[oöóò]/g, '[oöóò]')
                        .replace(/[uüúù]/g, '[uüúù]')
                        .replace(/\./g, '\\.');
                    let regexp = new RegExp(s, 'gi');
                    let match = regexp.exec(value);
                    if(match) {
                        matchs.push(match);
                    }
                });
            matchs.forEach((match) => {
                value = value.split(match[0]).join(`<span class="kan-highlight">${match[0]}</span>`);
            });
        }
        return value;
    }
}



// WEBPACK FOOTER //
// ./src/modules/common/pipes/highlight.ts